<template>
	<div class="card-element relative">
		<label
			v-if="label"
			class="won-blue text-sm font-medium"
		>
			{{ label }}
		</label>
		
		<slot />
	</div>
</template>

<script setup>
defineProps({
	label: {
		type: String,
		default: '',
	}
});
</script>


